import React, { useState } from 'react'
import useValidation from './hooks/useValidation'
import Input from './Input'
import PhoneInput from './PhoneInput'
import CnpjInput from './CnpjInput'
import { FormValidations } from './FormValidation'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import API from './api.js'

export default function SolicitarCotacao() {
  const initialFormState = {
    responsavel: '',
    empresa: '',
    telefone: '',
    email: '',
    cnpj: '',
    cidade: '',
    mensagem: '',
  }

  const dispatch = useDispatch()
  const [edit, setEdit] = useState(true)
  const [waiting, setWaiting] = useState(false)

  const [form, setForm] = useState(initialFormState)
  const { errors } = useValidation(form, FormValidations)

  const setInput = (newValue) => {
    setForm((form) => ({ ...form, ...newValue }))
  }

  const cart = useSelector((state) =>
    state.cart.itens.filter((item) => item.qtde > 0)
  )

  const saveFormData = async (request) => {
    return await API.post(`cotacao/salvar`, request)
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    if (
      form.responsavel.trim() == '' ||
      form.telefone.trim() == '' ||
      form.email.trim() == '' ||
      form.empresa.trim() == '' ||
      (form.cidade.trim() == '') | (form.cnpj.trim() == '')
    ) {
      alert('Preencha todos os campos do formulário.')
      return
    }

    if (!validarCNPJ(form.cnpj)) {
      setWaiting(false)
      alert('CNPJ inválido!')
      return
    }

    if (cart.length <= 0) {
      alert('Nenhum produto selecionado no carrinho.')
      return
    }

    let request = { ...form, produtosCotacao: cart }
    if (waiting) {
      return
    }

    setWaiting(true)

    saveFormData(request)
      .then((res) => {
        if (res.status !== 200) {
          throw new Error(`Request failed: ${res.status}`)
        }

        setWaiting(false)
        setEdit(false)
        dispatch({ type: 'CLEAR_CART' })
        alert(
          'Seu pedido foi encaminhado com sucesso, daremos um retorno em breve. Agradecemos a preferência. Qualquer dúvida entre em contato conosco através dos nossos canais de atendimento.'
        )
      })
      .catch(function (error) {
        setWaiting(false)
        alert(
          'Ocorreu uma falha ao enviar seu pedido. Tente novamente ou entre em contato conosco.'
        )
      })
  }

  function validarCNPJ(obj) {
    let cnpj = obj.replace(/[^\d]+/g, '')

    if (cnpj.trim() === '') return false

    if (cnpj.length !== 14) return false

    if (
      cnpj === '00000000000000' ||
      cnpj === '11111111111111' ||
      cnpj === '22222222222222' ||
      cnpj === '33333333333333' ||
      cnpj === '44444444444444' ||
      cnpj === '55555555555555' ||
      cnpj === '66666666666666' ||
      cnpj === '77777777777777' ||
      cnpj === '88888888888888' ||
      cnpj === '99999999999999'
    )
      return false

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho)
    let digitos = cnpj.substring(tamanho)
    let soma = 0
    let pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado != digitos.charAt(0)) return false

    tamanho = tamanho + 1
    numeros = cnpj.substring(0, tamanho)
    soma = 0
    pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
    if (resultado != digitos.charAt(1)) return false

    return true
  }

  return (
    <div className='container'>
      {edit && <h2 className='title text-center'>Pré Cadastro</h2>}

      {edit && (
        <form onSubmit={handleSubmit}>
          <div className='form-row'>
            <div className='col-sm-6 form-group'>
              <Input
                name='responsavel'
                onChange={(e) => setInput({ responsavel: e.target.value })}
                label='Responsável'
                value={form.responsavel}
                error={errors.responsavel}
              />
            </div>
            <div className='col-sm-6 form-group'>
              <Input
                name='empresa'
                onChange={(e) => setInput({ empresa: e.target.value })}
                label='Empresa'
                value={form.empresa}
                error={errors.empresa}
              />
            </div>
          </div>
          <div className='form-row'>
            <div className='col-sm-6 form-group'>
              <CnpjInput
                name='cnpj'
                onChange={(e) => setInput({ cnpj: e.target.value })}
                label='CNPJ'
                value={form.cnpj}
                error={errors.cnpj}
              />
            </div>
            <div className='col-sm-6 form-group'>
              <Input
                name='cidade'
                onChange={(e) => setInput({ cidade: e.target.value })}
                label='Cidade / Estado'
                value={form.cidade}
                error={errors.cidade}
              />
            </div>
          </div>
          <div className='form-row'>
            <div className='col-sm-6 form-group'>
              <PhoneInput
                name='telefone'
                onChange={(e) => setInput({ telefone: e.target.value })}
                label='Telefone'
                value={form.telefone}
                error={errors.telefone}
              />
            </div>
            <div className='col-sm-6 form-group'>
              <Input
                name='email'
                onChange={(e) => setInput({ email: e.target.value })}
                label='E-mail'
                value={form.email}
                error={errors.email}
              />
            </div>
          </div>
          <div className='form-row'>
            <div className='col-sm-12 form-group'>
              <Input
                name='mensagem'
                onChange={(e) => setInput({ mensagem: e.target.value })}
                label='Mensagem'
                value={form.mensagem}
                error={errors.mensagem}
              />
            </div>
          </div>

          <div className='form-row'>
            <div className='form-group' style={{ textAlign: 'end' }}>
              <button
                className='badge badge-pill'
                type='submit'
                style={{
                  cursor: 'pointer',
                  alignSelf: 'center',
                  backgroundColor: '#c9302c',
                  color: 'white',
                  marginTop: '15px',
                  marginBottom: '25px',
                  fontSize: '15px',
                  border: '0px',
                }}
              >
                {!!waiting ? 'Aguarde...' : 'ENVIAR SOLICITAÇÃO'}
              </button>
            </div>
          </div>
        </form>
      )}

      {edit && <h2 className='title text-center'>Produtos para cotação</h2>}

      {!edit && (
        <div className='text-center'> Pedido realizado com sucesso! </div>
      )}

      {edit && (
        <div className='shopping-cart'>
          {cart.length <= 0 && (
            <div className='text-center'> Nenhum produto </div>
          )}
          {cart.map((item) => (
            <div
              key={item.codipro}
              className='row cart'
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                marginLeft: '5px',
                marginTop: '10px',
              }}
            >
              <div
                style={{ marginLeft: '5px', width: '300px', textAlign: 'left' }}
              >
                {item.descricao}
              </div>

              <div
                style={{
                  marginRight: '5px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div
                  className='btn btn-outline-success'
                  onClick={() =>
                    dispatch({ type: 'ADD_TO_CART', item: { ...item, qtd: 1 } })
                  }
                >
                  <span className='glyphicon glyphicon-plus' />
                </div>

                <div>{item.qtde}</div>

                <div
                  className='btn btn-outline-success'
                  onClick={() =>
                    dispatch({ type: 'SUBTRACT_FROM_CART', item: item })
                  }
                >
                  <span className='glyphicon glyphicon-minus' />
                </div>

                <div
                  className='btn btn-outline-success'
                  onClick={() =>
                    dispatch({ type: 'REMOVE_FROM_CART', item: item })
                  }
                >
                  <span className='glyphicon glyphicon-trash' />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className='form-row'>
        <div className='col-sm-12 form-group text-center'>
          {edit && (
            <Link to='/' className='text-center'>
              <span
                className='badge badge-pill'
                style={{
                  cursor: 'pointer',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  color: '#c9302c',
                  marginTop: '15px',
                  marginBottom: '450px',
                  fontSize: '15px',
                }}
              >
                VOLTAR
              </span>
            </Link>
          )}
          {!edit && (
            <Link to='/' className='text-center'>
              <span
                className='badge badge-pill'
                style={{
                  cursor: 'pointer',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  color: '#c9302c',
                  marginTop: '15px',
                  marginBottom: '450px',
                  fontSize: '15px',
                }}
              >
                NOVO PEDIDO
              </span>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
